import { Icon } from "@iconify/react/dist/iconify.js";

type QuotationRequestLoaderProps = {
  generationProgress: number;
  generationProgressMessage: string;
};

export function QuotationRequestLoader({
  generationProgress,
  generationProgressMessage,
}: QuotationRequestLoaderProps) {
  return (
    <div className="QuotationRequestLoader grid place-content-center h-full border border-gray-200 rounded-md">
      <div className="grid gap-3 rounded-md p-3 shadow-md">
        <div className="grid gap-1 place-items-center">
          <Icon icon="mingcute:loading-line" className="text-5xl animate-spin" />
          <span className="text-center">Generation Progress: {generationProgress}%</span>
          <span className="text-center">{generationProgressMessage}</span>
        </div>
      </div>
    </div>
  );
}

export function QuotationRequestDocumentParsingLoader() {
  return (
    <div className="QuotationRequestDocumentParsingLoader grid place-content-center h-full">
      <div className="grid gap-3 rounded-md p-3 shadow-md">
        <div className="grid gap-1 place-items-center">
          <Icon icon="mingcute:loading-line" className="text-5xl animate-spin" />
          <span className="text-center">Parsing Document</span>
          <br />
          <span className="text-center">This may take a few seconds.</span>
          <span className="text-center">Please don't close this window.</span>
        </div>
      </div>
    </div>
  );
}
